/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualRentDto } from '../../models/backend-actual-rent-dto';
import { BackendPatchedActualRentRequestDto } from '../../models/backend-patched-actual-rent-request-dto';

export interface MonitoringActualsRentsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualRentRequestDto;
}

export function monitoringActualsRentsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsRentsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualRentDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsRentsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualRentDto>;
    }),
  );
}

monitoringActualsRentsPartialUpdate$FormData.PATH = '/api/monitoring/actuals/rents/{id}/';
